/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Import jQuery and make it available globally
import $ from 'jquery';
global.$ = global.jQuery = $;

// Import jQuery UI for autocomplete
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/themes/base/all.css';

// Sorting w/ acts_as_list
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/sortable';

// Rails UJS for data-confirm and other Rails helpers
import Rails from '@rails/ujs';
Rails.start();

// Bootstrap's JavaScript bundle with all components
import * as bootstrap from 'bootstrap';
global.bootstrap = bootstrap;

// Custom utilities
import { setupPhoneFormatting } from '../utils/phoneFormatter';
import localizeTimestamps from '../utils/localizeTimestamps';
window.localizeTimestamps = localizeTimestamps;
window.setupPhoneFormatting = setupPhoneFormatting;

// React on Rails
import ReactOnRails from 'react-on-rails';
import Questionnaire from '../components/Questionnaire';
import LocalTime from '../components/LocalTime';
import DataTableComponent from '../components/DataTable';
import Autocomplete from '../components/Autocomplete';
import S3Uploader from '../components/S3Uploader';
import EmbeddedSigning from '../components/EmbeddedSigning';

// Tell react_on_rails about our React components
ReactOnRails.register({
  Questionnaire, LocalTime, DataTableComponent, Autocomplete, S3Uploader, EmbeddedSigning
});

// Initialize phone number formatting for all tel input fields
document.addEventListener('DOMContentLoaded', () => {
  setupPhoneFormatting();
  localizeTimestamps();

  // Allow data-url attributes to redirect on click
  $('[data-url]').on('click', function() {
    window.location.href = $(this).data('url');
  });

  // Initialize sortable lists
  $('[data-sortable]').each(function() {
    $(this).sortable({
      handle: '.sort-handle',
      update: function(event, ui) {
        Rails.ajax({
          url: $(this).data("sortable"),
          type: "PATCH",
          data: $(this).sortable('serialize'),
        });
      }
    });
  });
});


// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)
